import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';

import {
    fetchSocialCalloutsByObjective,
} from 'services/social/duck';

import { SocialObjectiveDashboardComponent } from 'containers/dashboards/DashboardBaseComponent';
import LinkClicksModule from 'components/organisms/social/LinkClicksModule';

class LinkClicksContainer extends SocialObjectiveDashboardComponent {
    constructor(props, { objective = 'LINK_CLICKS' } = {}) {
        super(props, objective);
    }

    makeRequestsForData() {
        const entityId = this.getCurrentEntityId();
        const objective = this.getCurrentObjective();
        const payload = this.createPayload(entityId, objective);

        this.props.fetchSocialCalloutsByObjective(payload);
    }

    render() {
        return (
            <LinkClicksModule module={this.props.module}
                xAxisLabel={this.props.xAxisLabel}
                backfillBuckets={this.props.backfillBuckets}
                objective={this.getCurrentObjective()}
                layer={this.props.layer}
            />
        );
    }
}

const mapStateToProps = state => ({
    entityMeta: state.entities.meta,
    module: state.social.facebook.objectives.LINK_CLICKS,
    selectedTimeRange: state.config.selectedTimeRange,
    xAxisLabel: get(state, 'config.timeBuckets.config.xAxisLabel', 'Date'),
    backfillBuckets: get(state, 'config.timeBuckets.config.buckets', [])
});

export default connect(mapStateToProps, {
    fetchSocialCalloutsByObjective,
})(LinkClicksContainer);




// WEBPACK FOOTER //
// ./src/containers/dashboards/social/LinkClicksContainer.js